import type { DeepPartial } from '@luna/utils-ts';

import type { StandingOrders } from './StandingOrders';

export const RS: DeepPartial<StandingOrders> = {
    sweepOrders: {
        enabled: false,
    },
};
